export const REDUX_IDB_DB_NAME = 'speechifyWebDB';
export const REDUX_IDB_OBJECT_STORE_NAME = 'library';
